export const salesforceId = /[a-zA-Z0-9]{15}|[a-zA-Z0-9]{18}/;